// extracted by mini-css-extract-plugin
export default {"menuWrap":"Menu__menuWrap___q3bDI","isOpen":"Menu__isOpen___eYsKV","upperCase":"Menu__upperCase___ERryr"};